const PropTypes = require('prop-types');
const React = require('react');
const Sortable = require('react-sortable-hoc');
const Thumb = require('./thumb.jsx');

class ThumbList extends React.Component {
  renderThumbs() {
    return this.props.photos.map((photo, i) => {
      return (
        <Thumb
          key={i}
          index={i}
          photo={photo}
          onEdit={() => this.props.onEditPhoto(photo)}
          onRemove={() => this.props.onRemovePhoto(photo)}
          allowEdit={this.props.allowEdit}
        />
      );
    });
  }

  render() {
    return (
      <div className="img-uploader__thumbs">
        {this.renderThumbs()}
        {this.props.children}
      </div>
    );
  }
}

ThumbList.propTypes = {
  photos: PropTypes.array.isRequired,
  onEditPhoto: PropTypes.func.isRequired,
  onRemovePhoto: PropTypes.func.isRequired,
  allowEdit: PropTypes.bool.isRequired,
};

module.exports = Sortable.SortableContainer(ThumbList);



// WEBPACK FOOTER //
// ./javascripts/components/photos/thumb_list.jsx